// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClockCircleOutlinedSvg from "@fishx/icons-svg/es/asn/ClockCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClockCircleOutlinedSvg
  }));
};

ClockCircleOutlined.displayName = 'ClockCircleOutlined';
export default React.forwardRef(ClockCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ClockCircleOutlined.js
// module id = 2223
// module chunks = 0